import React from "react";
import { Button } from "@sumprio/ui";
import { Refresh2Icon } from "@sumprio/ui/icons";

export interface RefreshButtonProps {
  onRefresh: () => void | Promise<void>;
  iconOnly?: boolean;
  size?: "xs" | "sm" | "md" | "lg";
  variant?: "brand-secondaryGrey" | "brand-default";
  ariaLabel?: string;
  className?: string;
}

export default function RefreshButton({
  onRefresh,
  iconOnly = true,
  size = "xs",
  variant = "brand-secondaryGrey",
  ariaLabel = "Refresh",
  className,
}: RefreshButtonProps) {
  return (
    <Button
      iconOnly={iconOnly}
      icon={Refresh2Icon}
      variant={variant}
      size={size}
      onClick={onRefresh}
      aria-label={ariaLabel}
      className={className}
    />
  );
}
